import { render, staticRenderFns } from "./SubaccountSwitch.vue?vue&type=template&id=83b4d70c&scoped=true"
import script from "./SubaccountSwitch.vue?vue&type=script&lang=js"
export * from "./SubaccountSwitch.vue?vue&type=script&lang=js"
import style0 from "./SubaccountSwitch.vue?vue&type=style&index=0&id=83b4d70c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b4d70c",
  null
  
)

export default component.exports